module.exports = __webpack_public_path__ + "media/invite-a-friend/youre-entered-63baa532.png";